import { FormControl, InputLabel, Select, MenuItem, SelectChangeEvent } from "@mui/material";
import { useState } from "react";

const QuoteFilter = ({
	orderBy,
	handleChange,
}: {
	orderBy: string;
	handleChange: (value: string) => void;
}) => {
	const [open, setOpen] = useState(false);

	/**
	 * Handles the change event when selecting a sorting option.
	 *
	 * @function
	 * @param {SelectChangeEvent} event - The change event when selecting a sorting option.
	 */
	const onChange = (event: SelectChangeEvent) => {
		handleChange(event.target.value as string);
		handleClose();
	};

	const handleClose = () => setOpen(false);
	const handleOpen = () => setOpen(true);

	return (
		<FormControl
			onClick={() => setOpen(!open)}
			sx={{
				width: 250,
				border: "none",
				p: 1,
				"& .MuiFormLabel-root": {
					transform: "translate(1em, 1.35em) scale(1)",
					fontWeight: 600,
					fontSize: 13,
					border: "none",
				},
				"& .MuiInputBase-root": {
					borderRadius: 20,
					"& .MuiSelect-select": {
						borderRadius: 20,
						padding: "8.5px 4px",
						textAlign: "right",
						marginRight: "2em",
						fontSize: 14,
					},
				},
			}}
		>
			<InputLabel>Sort by</InputLabel>
			<Select
				size="small"
				value={orderBy}
				onChange={onChange}
				open={open}
				onClose={handleClose}
				onOpen={handleOpen}
			>
				<MenuItem value={"insuredName"} sx={{ fontSize: 14 }}>
					Insured name
				</MenuItem>
				<MenuItem value={"inceptionDate"} sx={{ fontSize: 14 }}>
					Inception date
				</MenuItem>
				<MenuItem value={"modifiedDate"} sx={{ fontSize: 14 }}>
					Modified date
				</MenuItem>
				{/* <MenuItem value={"status"} sx={{ fontSize: 14 }}>
					Status
				</MenuItem> */}
			</Select>
		</FormControl>
	);
};

export default QuoteFilter;
